import React from "react";

const DollarSign = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "#000"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      className="size-5"
    >
      <line x1="12" x2="12" y1="2" y2="22" />
      <path
        d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
        // className="size-3"
      />
    </svg>
  );
};

export default DollarSign;
